export default "__VITE_ASSET__DYJugUK9__"